import React, { useEffect } from 'react';
import styled from 'styled-components';
import { ColDiv } from 'styles';

export function Dim({ children, ...props }) {
  useEffect(() => {
    document.body.style.cssText = `overflow-y:hidden;`;
    return () => {
      document.body.style.cssText = ``;
    };
  }, []);

  return <DimStyle {...props}>{children}</DimStyle>;
}
export const DimStyle = styled(ColDiv)`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  overflow: hidden;
  align-items: center;
  justify-content: center;
`;
